import React from "react";
import "./InvalidAidPage.css";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "../../context/LanguageContext";
import { QuestionCircleOutlined } from "@ant-design/icons";
import logo from "../../assets/images/logo.png";

const InvalidAidPage = ({ title: defaultTitle, messages: defaultMessages }) => {
  const { language } = useLanguage();

  const isDefaultContent = defaultTitle === "尚未登录";
  const content = {
    CN: {
      title: isDefaultContent ? "尚未登录" : "尚未登录",
      messages: isDefaultContent
        ? ["请从业务目标网站进行登录，不要使用收藏的登录页面作为快捷登录链接。"]
        : ["由于长时间未操作，当前页面已经失效，请返回后重新进行登录"],
      contact: "如有问题，请联系 [信安SSO TS热线]",
    },
    EN: {
      title: isDefaultContent ? "Not Logged In" : "Not Logged In",
      messages: isDefaultContent
        ? [
            "Please log in from the target business website. Do not use bookmarked login pages as quick access links.",
          ]
        : [
            "Your session has expired due to inactivity. Please go back and log in again.",
          ],
      contact:
        "If you have any questions, please contact [InfoSec SSO TS Hotline]",
    },
  };

  const { title, messages, contact } = content[language];

  return (
    <div className="invalid-aid-container">
      <div className="invalid-aid-box">
        <div className="content">
          <div>
            <img src={logo} alt="Logo" className="invalid-aid-logo" />
          </div>
          {/* <h1 className="invalid-aid-title">{title}</h1> */}
          <div className="invalid-aid-message">
            {messages.map((msg, index) => (
              <p key={index}>{msg}</p>
            ))}
          </div>
          {/* <div className="contact-info">
            <QuestionCircleOutlined
              style={{
                marginRight: "4px",
                fontSize: "18px",
                verticalAlign: "middle",
              }}
            />
            <span>{contact}</span>
          </div> */}
        </div>
        <LanguageSwitcher />
      </div>
    </div>
  );
};
export default InvalidAidPage;